import { render, staticRenderFns } from "./DiagnosticsCard.vue?vue&type=template&id=41fc3b6c&scoped=true&"
import script from "./DiagnosticsCard.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsCard.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsCard.vue?vue&type=style&index=0&id=41fc3b6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc3b6c",
  null
  
)

export default component.exports